import { types, ConfigActionsType, IServerConfig } from '../types/config'

export const initialState: IServerConfig = {
  isLoading: false,
  allowedDomains: [],
}

export const serverConfig = (
  state = initialState,
  action: ConfigActionsType
): IServerConfig => {
  switch (action.type) {
    case types.GET_DATASREAM_ALLOWED_DOMAINS__START:
      return {
        ...state,
        isLoading: true,
      }
    case types.GET_DATASREAM_ALLOWED_DOMAINS__SUCCESS:
      return {
        ...state,
        isLoading: false,
        allowedDomains: action.domains,
      }
    case types.GET_DATASREAM_ALLOWED_DOMAINS__FAILURE:
    case types.GET_DATASREAM_ALLOWED_DOMAINS__CANCEL:
      return {
        ...state,
        isLoading: false,
      }
    default:
      return state
  }
}
